module.exports = __webpack_public_path__ + "img/img2.1d3541fa.png";